import { api } from "../../utils";

export const postAttachment = ({ values, config }) => {
  const formData = new FormData();
  Object.keys(values).forEach((key) => {
    formData.append(key, values[key]);
  });
  return api.post(`/tickets/add_attachment`, formData, config);
};
